"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementDefinitionMapping = void 0;
/**
 * Captures constraints on each element within the resource, profile, or extension.
 */
var ElementDefinitionMapping = /** @class */ (function () {
    function ElementDefinitionMapping() {
    }
    return ElementDefinitionMapping;
}());
exports.ElementDefinitionMapping = ElementDefinitionMapping;
